module.exports = __webpack_public_path__ + "static/media/choithramsHairCareS.490d4cde.png";